export const excludedCurrencies = ['RUB', 'HRK', 'BGN'];
